import React, { useRef, useState, useEffect } from 'react';

import HeaderHome from 'components/organisms/HeaderHome';
import HeaderHotel from 'components/organisms/HeaderHotel';
import Footer from 'components/organisms/Footer';
import CookieBar from 'components/molecules/CookieBar';
import ChatbotWidget from 'components/molecules/ChatbotWidget';

import popupStyles from 'components/molecules/Popup/index.css';
import styles from './index.css';

const App = ({ page, children, handleTouchStart, cookiesAccepted }) => {
	const cookieBarRef = useRef(null);
	const [cookieOffset, setCookieOffset] = useState(0);
	const [popupOffset, setPopupOffset] = useState(0);

	useEffect(() => {
		let timer;
		if (!cookiesAccepted) {
			// CookieBar is position:fixed so wrapper div height is 0.
			// Use firstElementChild to measure the actual CookieBar height.
			// Wait for the 3s animate-in to complete before measuring.
			timer = setTimeout(() => {
				const el = cookieBarRef.current && cookieBarRef.current.firstElementChild;
				if (el) setCookieOffset(el.offsetHeight);
			}, 3200);
		} else {
			setCookieOffset(0);
		}
		return () => clearTimeout(timer);
	}, [cookiesAccepted]);

	// The ad Popup is rendered deep inside page layouts (CSSTransition), so App
	// can't hold a ref to it. It mounts up to 3s before it fades into view and
	// unmounts several seconds after it fades out, so watching mount/unmount lags
	// the visual by seconds. Sync to the fade animation instead: the offset changes
	// exactly when the ad's fade-in/fade-out starts, and the widget's own 1s ease-in
	// transition (see ChatbotWidget/index.css) makes it rise/sink in step with the ad.
	useEffect(() => {
		const isPopup = el => el && el.classList && el.classList.contains(popupStyles.popup);
		const handleStart = e => {
			if (!isPopup(e.target)) return;
			// popup-exit-active is the leaving state (ad fading out); otherwise it's appearing.
			if (e.target.classList.contains('popup-exit-active')) {
				setPopupOffset(0);
			} else {
				setPopupOffset(e.target.offsetHeight);
			}
		};
		document.addEventListener('animationstart', handleStart);
		return () => document.removeEventListener('animationstart', handleStart);
	}, []);

	// CookieBar and Popup are both position:fixed bottom:0, so they overlap rather
	// than stack; float the widget above whichever is taller.
	const bottomOffset = Math.max(cookieOffset, popupOffset);

	return (
		<div onTouchStart={handleTouchStart}>
			{page === 'home' ? <HeaderHome page={page} /> : <HeaderHotel />}
			{children}
			<Footer />
			<div ref={cookieBarRef}>
				<CookieBar className={styles.cookieBar} />
			</div>
			{page !== 'home' && (
				<ChatbotWidget bottomOffset={bottomOffset} />
			)}
		</div>
	);
};

const AppLayout = () => App;

export default AppLayout;



// WEBPACK FOOTER //
// ./src/layouts/App/index.js